import React from 'react';
import { useTranslation } from 'react-i18next';
// @ts-ignore
var AppLauncherItem = function (_a) {
    var text = _a.text, url = _a.url, _b = _a.active, active = _b === void 0 ? false : _b;
    var t = useTranslation().t;
    return (React.createElement(React.Fragment, null,
        React.createElement("li", { className: "sdds-nav__app-launcher-item" },
            React.createElement("a", { href: url, className: "sdds-nav__app-launcher-item-core" }, t(text)))));
};
export default AppLauncherItem;
